// This script detects specific product templates and applies subscription functionality
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a product page
  const path = window.location.pathname;
  const isProductPage = path.includes('/products/');
  
  if (!isProductPage) return;
  
  // List of supported template names
  const supportedTemplates = [
    'product.ctr-custom-form',
    'product.subscription-flowfuel',
    'product.subscription-bedtimebliss',
    'product.ab-images'
  ];
  
  // First check: body classes (most reliable method)
  let isSupportedTemplate = false;
  const bodyClasses = document.body.classList;
  
  for (const template of supportedTemplates) {
    const templateClass = `template-${template.replace(/\./g, '-')}`;
    if (bodyClasses.contains(templateClass)) {
      console.log(`Template detected via body class: ${templateClass}`);
      isSupportedTemplate = true;
      break;
    }
  }
  
  // Second check: specific body classes for our templates
  if (!isSupportedTemplate) {
    if (bodyClasses.contains('badtimes') && 
        (bodyClasses.contains('subscription-flowfuel') || 
         bodyClasses.contains('subscription-bedtimebliss'))) {
      console.log('Template detected via special body classes');
      isSupportedTemplate = true;
    }
  }
  
  // Third check: look for subscription-enabled class on the page
  if (!isSupportedTemplate) {
    const subscriptionEnabledElements = document.querySelectorAll('.subscription-enabled');
    if (subscriptionEnabledElements.length > 0) {
      console.log('Template detected via subscription-enabled class');
      isSupportedTemplate = true;
    }
  }
  
  // Fourth check: look for custom form elements
  if (!isSupportedTemplate) {
    const customFormElements = document.querySelectorAll('.ctr-custom-form, .custom-form__container');
    if (customFormElements.length > 0) {
      console.log('Template detected via custom form elements');
      isSupportedTemplate = true;
    }
  }
  
  // If we're not on a supported template, exit
  if (!isSupportedTemplate) {
    console.log('Not a supported template for subscription functionality');
    return;
  }
  
  console.log('Supported template detected, initializing subscription functionality');
  
  // Find all frequency rows that need subscription components
  const frequencyRows = document.querySelectorAll('.custom-form--frequency-row');
  
  if (frequencyRows.length === 0) {
    console.log('No frequency rows found');
    return;
  }
  
  console.log(`Found ${frequencyRows.length} frequency rows`);
  
  frequencyRows.forEach((row, index) => {
    console.log(`Initializing frequency row ${index + 1}`);
    
    // Check if we already have a Skio component in this row
    const existingSkioComponent = row.querySelector('skio-plan-picker');
    
    if (existingSkioComponent) {
      console.log('Found existing skio-plan-picker component');
      
      // Make sure the script is loaded
      ensureScriptLoaded('skio-plan-picker-component.js');
      
      // Ensure the hidden input for selling_plan exists
      let hiddenInput = row.querySelector('input[name="selling_plan"]');
      if (!hiddenInput) {
        console.log('No hidden input found, creating one');
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.setAttribute('aria-hidden', 'true');
        hiddenInput.name = 'selling_plan';
        hiddenInput.value = '';
        row.appendChild(hiddenInput);
      } else {
        console.log('Hidden input found');
      }
    } else {
      console.log('No skio-plan-picker component found in this row');
    }
  });
});

// Helper function to ensure a script is loaded
function ensureScriptLoaded(scriptName) {
  const existingScript = document.querySelector(`script[src*="${scriptName}"]`);
  
  if (!existingScript) {
    console.log(`Loading script: ${scriptName}`);
    const script = document.createElement('script');
    script.src = window.Shopify ? 
      (window.Shopify.routes ? 
        window.Shopify.routes.root + `assets/${scriptName}` : 
        `/assets/${scriptName}`) : 
      `/assets/${scriptName}`;
    script.type = 'module';
    document.head.appendChild(script);
  } else {
    console.log(`Script already loaded: ${scriptName}`);
  }
} 